import { useMemo } from 'react';

/** The flag item fields the table filters on; also the filter names in the URL. */
export const FEATURE_FLAG_FILTER_FIELDS = ['users', 'brokerGroups', 'ledgers'];

/**
 * Filters feature flags in the browser by the users, broker groups and ledgers they directly
 * target. Like the Typesense filters in the CRM tables: several values in one filter match
 * any of them, and different filters must all match. Empty filters are ignored.
 */
export const useFeatureFlagFilter = (flags, filters) =>
	useMemo(() => {
		const activeFilters = FEATURE_FLAG_FILTER_FIELDS.filter((field) => filters[field]?.length);
		if (!activeFilters.length) {
			return flags;
		}
		return flags.filter((flag) =>
			activeFilters.every((field) =>
				filters[field].some((value) => (flag[field] ?? []).includes(value)),
			),
		);
	}, [flags, filters]);
